__turbopack_context__.v({
  "c-brand-truth": "BrandTruth-module-scss-module__kAyOAq__c-brand-truth",
  "gradient": "BrandTruth-module-scss-module__kAyOAq__gradient",
  "text": "BrandTruth-module-scss-module__kAyOAq__text",
  "visible": "BrandTruth-module-scss-module__kAyOAq__visible",
});
